import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export interface RelatorioSaboresTablePaginationProps {
  page: number;
  totalPages: number;
  totalRegistros: number;
  totalGeralFmt: string;
  totalPaginaFmt: string;
  isLoading: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

const RelatorioSaboresTablePagination: React.FC<
  RelatorioSaboresTablePaginationProps
> = ({
  page,
  totalPages,
  totalRegistros,
  totalGeralFmt,
  totalPaginaFmt,
  isLoading,
  onPrevious,
  onNext,
}) => {
  const podeAnterior = page > 1 && !isLoading;
  const podeProxima = page < totalPages && !isLoading;

  return (
    <div className="mt-4 flex flex-col gap-3 border-t border-neutral-100 pt-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
      <p className="text-sm text-neutral-600">
        <span className="font-semibold text-neutral-800">Total geral:</span>{" "}
        {totalGeralFmt}
        <span className="mx-2 hidden text-neutral-400 sm:inline">·</span>
        <span className="mt-2 block font-semibold text-neutral-800 sm:mt-0 sm:inline">
          Nesta página:
        </span>{" "}
        <span className="sm:inline">{totalPaginaFmt}</span>
        <span className="mt-1 block text-xs text-neutral-500 sm:ml-2 sm:mt-0 sm:inline">
          ({totalRegistros.toLocaleString("pt-BR")}{" "}
          {totalRegistros === 1 ? "registro" : "registros"} no relatório)
        </span>
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={!podeAnterior}
          onClick={() => {
            if (podeAnterior) onPrevious();
          }}
          className="inline-flex items-center rounded-lg border border-neutral-300 bg-white px-3 py-1.5 text-sm font-medium text-neutral-800 shadow-sm disabled:cursor-not-allowed disabled:opacity-40"
          aria-label="Página anterior"
        >
          <ChevronLeft size={18} />
        </button>
        <span className="min-w-[7rem] text-center text-sm text-neutral-700">
          Página {page} / {Math.max(totalPages, 1)}
        </span>
        <button
          type="button"
          disabled={!podeProxima}
          onClick={() => {
            if (podeProxima) onNext();
          }}
          className="inline-flex items-center rounded-lg border border-neutral-300 bg-white px-3 py-1.5 text-sm font-medium text-neutral-800 shadow-sm disabled:cursor-not-allowed disabled:opacity-40"
          aria-label="Próxima página"
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default RelatorioSaboresTablePagination;
